import type { AccountSummary } from '@paid-ui/types';

import { proxy } from 'valtio';
import { devtools } from 'valtio/utils';

import { userManager } from './user';

const initialState = {
  // This id is account matcher ID
  id: '',
  accountId: '',
  availableBalance: 0,
  reservedBalance: 0,
  totalBalance: 0,
  bsb: '',
  accountNumber: '',
  accountCreationTime: '',
  /** The account may only be funded internally, so it has no BSB or account number. */
  internalPaymentsOnly: false,
  /** Force update flag */
  forceUpdate: 0,
  loading: true,
};

export const savingsAccountManager = proxy(initialState);

devtools(savingsAccountManager, {
  name: 'Savings Account',
  enabled: false,
});

export const resetSavingsAccount = () => {
  Object.assign(savingsAccountManager, initialState);
};

export const saveSavingsAccountSummary = (data: AccountSummary) => {
  savingsAccountManager.availableBalance = data.availableBalance;
  savingsAccountManager.reservedBalance = data.reservedBalance;
  savingsAccountManager.totalBalance = data.totalBalance;
  // The summary still carries the BSB and account number even for an internal
  // payments only account, so don't write back what the account list masked.
  if (!savingsAccountManager.internalPaymentsOnly) {
    savingsAccountManager.bsb = data.bsb;
    savingsAccountManager.accountNumber = data.accountNumber;
  }
  if (data.accountCreationTime) {
    savingsAccountManager.accountCreationTime = data.accountCreationTime;
  }
  savingsAccountManager.loading = false;
};

export const stopLoading = () => {
  savingsAccountManager.loading = false;
};

export const reloadSavingsAccount = () => {
  const { forceUpdate } = savingsAccountManager;
  const { isAccountReady } = userManager;
  if (!isAccountReady) return;
  savingsAccountManager.loading = true;
  savingsAccountManager.forceUpdate = forceUpdate > 100 ? 1 : forceUpdate + 1;
};
